var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9198 8.99998C16.9079 10.6706 16.4017 12.3003 15.4649 13.6836C14.5282 15.067 13.2028 16.142 11.6559 16.7731C10.1091 17.4042 8.40996 17.5632 6.77285 17.23C5.13575 16.8969 3.63394 16.0864 2.45678 14.9009C1.27962 13.7154 0.479823 12.2079 0.158226 10.5685C-0.163372 8.92908 0.00763149 7.23114 0.649674 5.68877C1.29172 4.1464 2.37605 2.82866 3.76596 1.90169C5.15587 0.974716 6.78913 0.480022 8.45979 0.47998C9.57472 0.483913 10.6779 0.70741 11.7065 1.13771C12.735 1.56801 13.6688 2.19669 14.4544 2.98784C15.2399 3.779 15.862 4.71714 16.285 5.74871C16.708 6.78027 16.9237 7.88506 16.9198 8.99998Z",
    fill: "#BCBEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2015 9.00003C26.2015 13.428 24.3115 17.022 21.9715 17.022C19.6315 17.022 17.7715 13.422 17.7715 9.00003C17.7715 4.57803 19.6675 0.978027 21.9715 0.978027C24.2755 0.978027 26.2015 4.57803 26.2015 9.00003Z",
    fill: "#BCBEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.00029C30 12.9663 29.334 16.2003 28.512 16.2003C27.69 16.2003 27 12.9663 27 9.00029C27 5.03429 27.666 1.80029 28.488 1.80029C29.31 1.80029 30 5.03429 30 9.00029Z",
    fill: "#BCBEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/Medium Icon.49708522fe536266ccb75e9accb29391.svg";
export { ForwardRef as ReactComponent };